import axios from "axios";
import { fpoMembersUrl, fpoMemberLocationsUrl } from "../constants/apis";
import { getAuthToken, getFPOData } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/members?fpo=<id> — list members of the caller's FPO with stats.
 * Accepts optional filters: search, status, is_active, village, tehsil, page, page_size.
 */
export const getFPOMembers = async (params = {}) => {
    const fpoId = getFPOData()?.id;
    const response = await axios.get(fpoMembersUrl, {
        ...authHeaders(),
        params: { fpo: fpoId, ...params },
    });
    return response;
};

/**
 * POST /fpo/members/ — register a farmer against the caller's FPO (fpo_admin only).
 * Looks the person up by mobile_number; creates or updates their user/address, then
 * creates a pending FPOMembers row. Returns 409 with `warning: true` if that person
 * is already a member of another FPO.
 */
export const addFPOMember = async (data) => {
    const response = await axios.post(fpoMembersUrl, data, authHeaders());
    return response;
};

/**
 * PATCH /fpo/members/ — partially update a member of the caller's FPO (fpo_admin only).
 * Body must include `id`; any of share_held, share_amount, status, rejection_reason,
 * is_active, member_since are optional. Approving a code-less member auto-assigns one.
 */
export const updateFPOMember = async (id, data) => {
    const response = await axios.patch(fpoMembersUrl, { id, ...data }, authHeaders());
    return response;
};

/**
 * GET /fpo/members/locations/?fpo=<id> — distinct villages/tehsils among the
 * caller's FPO's members, for populating filter dropdowns.
 */
export const getFPOMemberLocations = async () => {
    const fpoId = getFPOData()?.id;
    const response = await axios.get(fpoMemberLocationsUrl, {
        ...authHeaders(),
        params: { fpo: fpoId },
    });
    return response;
};
